import { lazy } from 'react';
import { IRouteProps } from './types';

/** C端路由 */
const cRouters: IRouteProps[] = [
  {
    path: 'roadBook',
    title: '路书管理',
    index: false,
    permissionKey: 'ADMIN14',
    icon: 'roadbookmap',
    children: [
      {
        path: 'commentList',
        title: '评论管理',
        permissionKey: 'ADMIN1401',
        element: lazy(() => import('src/views/roadBook/commentList')),
      },
      {
        path: 'wordList',
        title: '屏蔽词管理',
        permissionKey: 'ADMIN1305',
        element: lazy(() => import('src/views/roadBook/shieldingWord')),
      },
      {
        path: 'adventure',
        title: '周边奇遇记配置',
        permissionKey: 'ADMIN1402',
        element: lazy(() => import('src/views/roadBook/adventure/list')),
      },
    ],
  },
  {
    path: 'publishManage',
    title: '社区',
    index: false,
    permissionKey: 'ADMIN12',
    icon: 'publishManage',
    children: [
      {
        path: 'publish',
        title: '内容发布管理',
        permissionKey: 'ADMIN12',
        element: lazy(() => import('src/views/publishManage')),
      },
      {
        path: 'publish',
        title: '内容发布管理',
        permissionKey: 'ADMIN12',
        isFree: true,
        cache: false,
        children: [
          {
            path: 'detail',
            title: '详情',
            permissionKey: 'ADMIN12',
            element: lazy(() => import('src/views/publishManage/listEditor')),
          },
          {
            path: 'publish',
            title: '发布',
            permissionKey: 'ADMIN12',
            element: lazy(() => import('src/views/publishManage/publishEditor')),
          },
        ],
      },
    ],
  },
  // {
  //   path: 'mall',
  //   title: '商城管理',
  //   index: false,
  //   permissionKey: 'ADMIN10',
  //   icon: 'mall',
  //   cache: false,
  //   isHref: true,
  //   onClick: () => {
  //     const token = sessionStorage.getItem('adminToken');
  //     window.open(`${process.env.REACT_APP_MALL_URL}?token=${token}`);
  //   },
  // },
  {
    path: 'equityManagement',
    title: '会员权益',
    index: false,
    permissionKey: 'ADMIN12',
    icon: 'equityManagement',
    children: [
      {
        path: 'equityList',
        title: '权益管理',
        permissionKey: 'ADMIN12',
        element: lazy(() => import('src/views/equityManagement/equity/index')),
      },
      {
        path: 'equityList',
        title: '权益管理',
        permissionKey: 'ADMIN12',
        isFree: true,
        cache: false,
        children: [
          {
            path: 'detail',
            title: '详情',
            permissionKey: 'ADMIN12',
            element: lazy(() => import('src/views/publishManage/listEditor')),
          },
        ],
      },
      {
        path: 'exclusivePrivileges',
        title: '专属权益',
        permissionKey: 'ADMIN1305',
        element: lazy(() => import('src/views/equityManagement/exclusivePrivileges')),
      },
    ],
  },
  {
    path: 'marketingConfig',
    title: '营销配置',
    icon: 'configuration',
    // permissionKey: 'ADMIN1504',
    children: [
      {
        path: 'carLoanApply',
        title: '车抵贷管理',
        permissionKey: 'ADMIN1510',
        element: lazy(() => import('src/views/CarLoanApply/index')),
      },
    ],
  },
  {
    path: 'orderManagement',
    title: '订单管理',
    index: false,
    permissionKey: 'ADMIN1505',
    icon: 'roadBook',
    children: [
      {
        path: 'chargeOrder',
        title: '充电订单管理',
        permissionKey: 'ADMIN150501',
        element: lazy(() => import('src/views/orderManagement/chargeOrder/index')),
      },
      {
        path: 'chargeOrder',
        title: '充电订单详情',
        permissionKey: 'ADMIN150501',
        isFree: true,
        cache: false,
        children: [
          {
            path: 'detail',
            title: '详情',
            permissionKey: 'ADMIN150501',
            element: lazy(() => import('src/views/orderManagement/chargeOrderDetail/index')),
          },
        ],
      },
    ],
  },
  {
    path: 'configs',
    title: '小程序配置',
    permissionKey: 'ADMIN1503',
    icon: 'activity',
    children: [
      {
        path: 'configuration',
        title: '运营配置',
        permissionKey: 'ADMIN1504',
        element: lazy(() => import('src/views/Configuration/index')),
      },
      {
        path: 'banner',
        title: 'Banner管理',
        permissionKey: 'ADMIN1502',
        element: lazy(() => import('src/views/Banner/index')),
      },
      {
        path: 'active',
        title: '营销活动管理',
        permissionKey: 'ADMIN1503',
        children: [
          {
            path: '',
            index: true,
            isFree: true,
            title: '营销活动列表',
            permissionKey: 'ADMIN150301',
            element: lazy(() => import('src/views/Active/List/index')),
          },
          {
            path: 'add',
            title: '营销活动新增',
            index: true,
            isFree: true,
            permissionKey: 'ADMIN150302',
            element: lazy(() => import('src/views/Active/Add/index')),
          },
          {
            path: 'edit',
            title: '营销活动编辑',
            index: true,
            isFree: true,
            permissionKey: 'ADMIN150304',
            element: lazy(() => import('src/views/Active/Add/index')),
          },
          {
            path: 'detail',
            title: '营销活动详情',
            index: true,
            isFree: true,
            permissionKey: 'ADMIN150301',
            element: lazy(() => import('src/views/Active/Add/index')),
          },
        ],
      },
      {
        path: 'shippingFee',
        title: '邮费配置',
        permissionKey: 'ADMIN151101',
        element: lazy(() => import('src/views/ShippingFee/index')),
      },
    ],
  },
  {
    path: 'toolSupport',
    title: '工具支持',
    index: false,
    permissionKey: 'ADMIN1501',
    icon: 'jifen',
    children: [
      {
        path: 'eventLottery',
        title: '幸运大抽奖',
        permissionKey: 'ADMIN1501',
        children: [
          {
            path: '',
            title: '幸运大抽奖',
            index: true,
            isFree: true,
            permissionKey: 'ADMIN1501',
            element: lazy(() => import('src/views/eventLottery/index')),
          },
          {
            path: 'nineGrid',
            title: '幸运大抽奖',
            permissionKey: 'ADMIN1501',
            isFree: true,
            cache: false,
            children: [
              {
                path: 'list',
                title: '活动列表',
                permissionKey: 'ADMIN150101',
                element: lazy(() => import('src/views/eventLottery/NineGrid/List/index')),
              },
              {
                path: 'add',
                title: '活动新增',
                cache: false,
                permissionKey: 'ADMIN150102',
                element: lazy(() => import('src/views/eventLottery/NineGrid/Add/index')),
              },
              {
                path: 'edit',
                title: '活动编辑',
                cache: false,
                permissionKey: 'ADMIN150107',
                element: lazy(() => import('src/views/eventLottery/NineGrid/Add/index')),
              },
              {
                path: 'detail',
                title: '活动详情',
                permissionKey: 'ADMIN150103',
                cache: false,
                element: lazy(() => import('src/views/eventLottery/NineGrid/Add/index')),
              },
              {
                path: 'lotteryRecords',
                title: '抽奖记录',
                cache: false,
                permissionKey: 'ADMIN150106',
                element: lazy(() => import('src/views/eventLottery/NineGrid/LotteryRecords/index')),
              },
            ],
          },
        ],
      },
      {
        path: 'couponManagement',
        title: '充电优惠券',
        index: false,
        permissionKey: 'ADMIN1506',
        cache: false,
        children: [
          {
            path: '',
            index: true,
            isFree: true,
            title: '充电优惠券',
            cache: false,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponManagement/couponList/index')),
          },
          {
            path: 'addCoupon',
            title: '新增',
            cache: false,
            isFree: true,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponManagement/addCoupon/index')),
          },
          {
            path: 'couponDetail',
            title: '详情',
            cache: false,
            isFree: true,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponManagement/couponDetail/index')),
          },
          {
            path: 'sendCouponList',
            title: '充电优惠券使用记录',
            isFree: true,
            permissionKey: 'ADMIN150602',
            element: lazy(() => import('src/views/couponManagement/sendCouponList/index')),
          },
        ],
      },
      {
        path: 'couponMall',
        title: '商城优惠券',
        permissionKey: 'ADMIN1506',
        children: [
          {
            path: '',
            index: true,
            isFree: true,
            title: '商城优惠券',
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponMall/couponList/index')),
          },
          {
            path: 'add',
            title: '新增',
            cache: false,
            isFree: true,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponMall/addCoupon/index')),
          },
          {
            path: 'edit',
            title: '编辑',
            cache: false,
            isFree: true,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponMall/addCoupon/index')),
          },
          {
            path: 'detail',
            title: '详情',
            cache: false,
            isFree: true,
            permissionKey: 'ADMIN150601',
            element: lazy(() => import('src/views/couponMall/addCoupon/index')),
          },
          {
            path: 'sendCouponList',
            title: '商城优惠券使用记录',
            isFree: true,
            permissionKey: 'ADMIN150602',
            element: lazy(() => import('src/views/couponMall/sendCouponList/index')),
          },
        ],
      },
      {
        path: 'couponPackage',
        title: '优惠券礼包',
        permissionKey: 'ADMIN1503',
        children: [
          {
            path: '',
            index: true,
            isFree: true,
            cache: false,
            title: '优惠券礼包',
            permissionKey: 'ADMIN150301',
            element: lazy(() => import('src/views/couponPackage/list/index')),
          },
          {
            path: 'add',
            title: '优惠券礼包新增',
            isFree: true,
            cache: false,
            permissionKey: 'ADMIN150302',
            element: lazy(() => import('src/views/couponPackage/add/index')),
          },
          {
            path: 'edit',
            title: '优惠券礼包编辑',
            isFree: true,
            cache: false,
            permissionKey: 'ADMIN150304',
            element: lazy(() => import('src/views/couponPackage/add/index')),
          },
          {
            path: 'detail',
            title: '优惠券礼包详情',
            isFree: true,
            cache: false,
            permissionKey: 'ADMIN150301',
            element: lazy(() => import('src/views/couponPackage/add/index')),
          },
          {
            path: 'claimRecords',
            title: '领取记录',
            isFree: true,
            permissionKey: 'ADMIN150305',
            element: lazy(() => import('src/views/couponPackage/claimRecords/index')),
          },
        ],
      },
    ],
  },
  {
    path: 'invoiceManagement',
    title: '发票管理',
    permissionKey: 'ADMIN1507',
    icon: 'banner',
    element: lazy(() => import('src/views/invoiceManagement/index')),
  },
  {
    path: 'userWalletManagement',
    title: '用户钱包管理',
    permissionKey: 'ADMIN1508',
    icon: 'banner',
    element: lazy(() => import('src/views/userWalletManagement/index')),
  },
];

export default cRouters;
